export default function Spesifikasi({ data }) {
  const tanggalPenawaran = new Date(data.tanggalPenawaran);
  return (
    <div className="block md:flex">
      <table>
        <tbody className="text-left">
          <tr>
            <th className="pr-4 py-1 font-normal">Tipe</th>
            <td className="px-4 py-1 capitalize">{data.tipe}</td>
          </tr>
          <tr>
            <th className="pr-4 py-1 font-normal">Luas Tanah</th>
            <td className="px-4 py-1 capitalize">
              {data.luasTanah} m<sup>2</sup>
            </td>
          </tr>
          <tr>
            <th className="pr-4 py-1 font-normal">Bahan Bangunan</th>
            <td className="px-4 py-1 capitalize">{data.bahan}</td>
          </tr>
          <tr>
            <th className="pr-4 py-1 font-normal">Tahun Dibangun</th>
            <td className="px-4 py-1 capitalize">{data.dibangun}</td>
          </tr>
          <tr>
            <th className="pr-4 py-1 font-normal">Batas Tanah</th>
            <td className="px-4 py-1 capitalize">
              <ul>
                <li>
                  Depan:{" "}
                  <span className="capitalize">{data.batasTanah[0]}</span>
                </li>
                <li>
                  Kiri: <span className="capitalize">{data.batasTanah[1]}</span>
                </li>
                <li>
                  Kanan:{" "}
                  <span className="capitalize">{data.batasTanah[2]}</span>
                </li>
                <li>
                  Belakang:{" "}
                  <span className="capitalize">{data.batasTanah[3]}</span>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody className="text-left">
          <tr>
            <th className="pr-4 md:px-4 py-1 font-normal">Sertifikasi</th>
            <td className="px-4 py-1 uppercase">{data.sertifikasi}</td>
          </tr>
          <tr>
            <th className="pr-4 md:px-4 py-1 font-normal">Luas Bangunan</th>
            <td className="px-4 py-1 capitalize">
              {data.luasBangun} m<sup>2</sup>
            </td>
          </tr>
          <tr>
            <th className="pr-4 md:px-4 py-1 font-normal">Jumlah Lantai</th>
            <td className="px-4 py-1 capitalize">{data.jumlahLantai}</td>
          </tr>
          <tr>
            <th className="pr-4 md:px-4 py-1 font-normal">Tahun Direnovasi</th>
            <td className="px-4 py-1 capitalize">{data.direnov}</td>
          </tr>
          <tr>
            <th className="pr-4 md:px-4 py-1 font-normal">Posisi Bangunan</th>
            <td className="px-4 py-1 capitalize">{data.posisiBangunan}</td>
          </tr>
          <tr>
            <th className="pr-4 md:px-4 py-1 font-normal">Orientasi</th>
            <td className="px-4 py-1 capitalize">{data.orientasi}</td>
          </tr>
          <tr>
            <th className="pr-4 md:px-4 py-1 font-normal">Elevasi</th>
            <td className="px-4 py-1 capitalize">{data.elevasi}</td>
          </tr>
          <tr>
            <th className="pr-4 md:px-4 py-1 font-normal">Tanggal Penawaran</th>
            {data.tanggalPenawaran && (
              <td className="px-4 py-1 capitalize">{`${tanggalPenawaran.getDate()}-${tanggalPenawaran.getMonth()}-${tanggalPenawaran.getFullYear()}`}</td>
            )}
            {!data.tanggalPenawaran && (
              <td className="px-4 py-1 capitalize">-</td>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
